
import { defineComponent } from 'vue';
import Card from '@/components/Card.vue';
import Button from '@/components/Button.vue';

export default defineComponent({
  name: 'Modal',
  props: {
    title: String,
  },
  components: {
    Card,
    Button,
  },
});
